import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-luf-star",
  "use": "fi-icon-custom-luf-star-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"fi-icon-custom-luf-star\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#FFF\" />\n        <path fill=\"#0073CF\" d=\"M7 3l1.236 2.633L11 6.056l-2 2.05L9.472 11 7 9.633 4.528 11 5 8.105l-2-2.05 2.764-.422z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol